<template>
  <div class="w-full py-4 bg-green-600 text-gray-200 hover:text-white">
    <p class="text-center font-light text-sm md:text-lg tracking-wider">
      <a
        href="https://kamaludin.tech/"
        class="font-semibold text-white cursor-pointer hover:underline"
        >Kamaludin.tech</a
      >
      &copy; Made With 💻 and ⚡
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
